import { t } from "@travily/i18n";
import { ButtonDock } from "@ui/components/ButtonDock";
import { Dialog } from "@ui/components/Dialog";
import { StandardButton } from "@ui/components/StandardButton";
import magicLinkSentCharacter from "./assets/magic-link-sent-character-animated.webp";

const INBOX_URLS: Record<string, string> = {
  "gmail.com": "https://mail.google.com",
  "googlemail.com": "https://mail.google.com",
  "outlook.com": "https://outlook.live.com/mail/0/",
  "hotmail.com": "https://outlook.live.com/mail/0/",
  "live.com": "https://outlook.live.com/mail/0/",
  "msn.com": "https://outlook.live.com/mail/0/",
  "icloud.com": "https://www.icloud.com/mail",
  "me.com": "https://www.icloud.com/mail",
  "mac.com": "https://www.icloud.com/mail",
  "yahoo.com": "https://mail.yahoo.com",
  "proton.me": "https://mail.proton.me",
  "protonmail.com": "https://mail.proton.me",
  "fastmail.com": "https://app.fastmail.com/mail",
};

export function inboxUrlFor(email: string): string | null {
  const domain = email.split("@")[1]?.toLowerCase() ?? "";
  return INBOX_URLS[domain] ?? null;
}

export interface SentStepProps {
  inboxUrl: string | null;
  onBack: () => void;
  onClose: () => void;
}

export function SentStep({ inboxUrl, onBack, onClose }: SentStepProps) {
  const ctaLabel = inboxUrl?.includes("mail.google.com")
    ? t("components.views.magic_links.email_modal.sent.cta_gmail")
    : t("components.views.magic_links.email_modal.sent.cta_inbox");

  const tryDifferentEmail = (
    <StandardButton color="neutral" onPress={onBack} size="44">
      {t("components.views.magic_links.email_modal.sent.back_to_form")}
    </StandardButton>
  );

  const openInbox = inboxUrl ? (
    <StandardButton color="pink" href={inboxUrl} rel="noreferrer" size="44" target="_blank">
      {ctaLabel}
    </StandardButton>
  ) : null;

  return (
    <>
      <Dialog.Header onClose={onClose} title={t("components.views.magic_links.email_modal.sent.title")} />
      <Dialog.Body centered>
        <div className="flex flex-col items-center gap-4 px-1 text-center">
          <img
            alt={t("components.views.magic_links.email_modal.sent.illustration_alt")}
            className="h-auto w-[140px]"
            height={150}
            src={magicLinkSentCharacter}
            width={200}
          />
          <p className="text-base text-neutral-700">{t("components.views.magic_links.email_modal.sent.body")}</p>
        </div>
      </Dialog.Body>
      <Dialog.Footer>
        <ButtonDock
          primaryAction={openInbox ?? tryDifferentEmail}
          secondaryAction={openInbox ? tryDifferentEmail : undefined}
        />
      </Dialog.Footer>
    </>
  );
}
